import { t } from "i18next";
import { Button, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Athlete, AthleteMeasurement, emptyAthlete } from "../../../../interfaces/athlete";
import { createAthleteMeasurement, getAthleteMeasurement, getAthleteSingle } from "../../../../services/athlete";
import { Media } from "../../../../interfaces/media";
import DataTable from "react-data-table-component";
import moment from "moment";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { getPaginationOptions, tableStyles } from "../../../../util/data-table";

interface CoachAthleteMeasurementProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function CoachAthleteMeasurement(props: CoachAthleteMeasurementProps) {
    const [athlete, setAthlete] = useState<Athlete>(emptyAthlete);
    const [media, setMedia] = useState<Media[]>([]);
    const [loaded, setLoaded] = useState(true);
    const [athleteMeasurements, setAthleteMeasurements] = useState<AthleteMeasurement[]>([]);
    const [showAdd, setShowAdd] = useState(false);

    useEffect(() => {
        Promise.all([
            getAthleteSingle(props.id),
            getAthleteMeasurement(props.id)
        ]).then((response: any) => {
            setAthlete(response[0].data);
            const newMedia = response[0].data.avatar.map((m: Media) => {
                return m;
            });
            setMedia(newMedia);
            setAthleteMeasurements(response[1].data);
            setLoaded(true);
        });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            athlete_id: athlete.id,
            measurement_date: event.target.measurement_date.value,
            weight: event.target.weight.value,
            height: event.target.height.value,
            bmi: event.target.bmi.value,
            fm: event.target.fm.value,
            bm: event.target.bm.value
        }
        createAthleteMeasurement(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    const newAthleteMeasurements = [
                        ...response.data.data,
                        ...athleteMeasurements
                    ];
                    setAthleteMeasurements(newAthleteMeasurements);
                    setShowAdd(false);
                } else {
                    alert(response.data.message);
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleDelete = () => {

    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAdd(true);
    }

    const handleCloseAddNew = (event: any) => {
        event.preventDefault();
        setShowAdd(false);
    }
    
    const CustomActions = (row: any) => (
        <span>
            {/*<a href="#" className="icon-link edit" title={ t("edit") } onClick={ handleEdit } data-id={ row.row.id }>
                <i className="bi bi-pencil-square"></i>
            </a>*/}
            <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ row.row.id }>
                <i className="bi bi-trash"></i>
            </a>
        </span>
    );

    const CustomDate = (row: any ) => (
        <span>
            { moment(row.row.measurement_date).format("DD/MM/YYYY") }
        </span>
    );

    const columns = [
        {
            id: 'id',
            name: '#',
            style: { maxWidth: '80px' },
            selector: (row: any) => row.id,
            sortable: true
        },
        {
            id: 'measurement_date',
            name: t('measurement_date'),
            selector: (row: any) => row.athlete_name,
            sortable: true,
            cell: (row: any) => <CustomDate row={row} />,
        },
        {
            id: 'weight',
            name: t('weight_label'),
            selector: (row: any) => row.weight,
            sortable: true
        },
        {
            id: 'height',
            name: t('height_label'),
            center: true,
            selector: (row: any) => row.height,
            sortable: true
        },
        {
            id: 'bmi',
            name: t('bmi_label'),
            center: true,
            selector: (row: any) => row.bmi,
            sortable: true
        },
        {
            id: 'fm',
            name: t('fm_label'),
            center: true,
            selector: (row: any) => row.fm,
            sortable: true
        },
        {
            id: 'bm',
            name: t('bm_label'),
            center: true,
            selector: (row: any) => row.bm,
            sortable: true
        },
        {
            id: 'actions',
            name: t("actions"),
            cell: (row: any) => <CustomActions row={row} />,
        }

    ];
    
    return (
        <Modal className="admin-athlete-measurement-container" show={ true }
            onHide={ handleClose } size="xl"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("athlete_measurements") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { !loaded && 
                    <LoadingSpinner />
                }
                { loaded &&
                    <div className="athlete-measurements-container">
                        <div className="subtable-container">
                            <DataTable
                                columns={ columns }
                                data={athleteMeasurements}
                                // selectableRows={ true }
                                // selectableRowsHighlight={ true }
                                responsive={ true }
                                striped={ true }
                                highlightOnHover={ true }
                                defaultSortFieldId={ 'measurement_date' }
                                defaultSortAsc={ false }
                                pagination={ true }
                                customStyles={ tableStyles }
                                paginationComponentOptions={ getPaginationOptions() }
                            />
                        </div>
                        { !showAdd &&
                            <a className="measurement-add-new" href="#" onClick={ handleAddNew }>
                                <i className="bi bi-plus-circle"></i>
                            </a>
                        }
                        { showAdd && 
                            <Form onSubmit={ handleSave } className="add-measurement">
                                <a href="#" className="close" onClick={ handleCloseAddNew }>
                                </a>
                                <div className="fields">
                                    <Form.Control type="hidden" name="id" required defaultValue={ athlete.id } />
                                    <Form.Group className="mb-3" controlId="measurement_date">
                                        <Form.Label aria-required="true">{ t("measurement_date") }</Form.Label>
                                        <Form.Control type="date" name="measurement_date" required />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="weight">
                                        <Form.Label aria-required="true">{ t("weight_label") }</Form.Label>
                                        <Form.Control type="number" name="weight" required />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="height">
                                        <Form.Label aria-required="true">{ t("height_label") }</Form.Label>
                                        <Form.Control type="number" name="height" required />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="bmi">
                                        <Form.Label aria-required="true">{ t("bmi_label") }</Form.Label>
                                        <Form.Control type="number" name="bmi" />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="fm">
                                        <Form.Label aria-required="true">{ t("fm_label") }</Form.Label>
                                        <Form.Control type="number" name="fm" />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="bm">
                                        <Form.Label aria-required="true">{ t("bm_label") }</Form.Label>
                                        <Form.Control type="number" name="bm" />
                                    </Form.Group>
                                </div>
                                <div className="actions">
                                    <Button type="submit" variant="primary">
                                        { t("Save") }
                                    </Button>
                                    {/*<Button variant="secondary" onClick={ handleCloseAddNew }>
                                        { t("Close") }
                                    </Button>*/}
                                </div>
                            </Form>
                        }
                    </div>
                }
            </Modal.Body>
        </Modal>
    );
}